"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FilePDFSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25 28H7v-2H5v2a2 2 0 002 2h18a2 2 0 002-2v-2h-2zM26.42 8.43l-5.83-5.84A2 2 0 0019.18 2H7a2 2 0 00-2 2v9h2V4h11v5a2 2 0 002 2h5v2h2V9.84a2 2 0 00-.58-1.41z"/><path d="M16 17.86h-.6v3.28h.6c.75 0 1.29-.31 1.29-1.63-.01-.94-.29-1.65-1.29-1.65zM10.26 17.83h-.67v1.71h.52c.62 0 1-.23 1-.86a.78.78 0 00-.85-.85z"/><path d="M28 13H4a2 2 0 00-2 2v9a2 2 0 002 2h24a2 2 0 002-2v-9a2 2 0 00-2-2zm-17.46 7.52h-.95v1.65H8.31v-5.34h2.25a1.76 1.76 0 011.87 1.85 1.75 1.75 0 01-1.89 1.84zm5.66 1.65h-2.1v-5.34h2.1c1.66 0 2.41 1 2.41 2.65s-.77 2.69-2.41 2.69zm7.73-4.3h-2.26v1.28h2.06v1h-2.06v2h-1.29v-5.32h3.55z"/>';
var FilePDFSVG = function FilePDFSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FilePDFSVG = FilePDFSVG;
FilePDFSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FilePDFSVG);
exports.default = _default;